<template>
  <div class="contain">
    <!-- PC端：原有头部按钮区域 -->
    <div class="pc-header showPC">
      <div style="display: flex; justify-content: flex-end">
        <button class="detail-button cursor-pointer" @click="getPdf()">列印 Print</button>
      </div>
      <div
          class="el-icon-back cursor-pointer"
          style="font-size: 1.5rem; line-height: 2rem; font-weight: bold; position: absolute; margin-left: calc(5vw - 2rem); margin-top: 2.25rem"
          @click="onBack"
      ></div>
    </div>

    <!-- ========== 手机端：MTR支付凭证风格（带返回按钮） ========== -->
    <div class="mtr-wrapper showPhone">
      <!-- MTR风格顶部（带返回按钮） -->
      <div class="mtr-header">
        <div class="mtr-back-btn" @click="onBack">
          <i class="el-icon-back"></i>
        </div>
        <div class="mtr-title">訂閱付費紀錄詳細</div>
        <div class="mtr-amount">{{ addComma(tableData.payPrice) }}</div>
      </div>

      <!-- MTR风格信息列表 -->
      <div class="mtr-info-list">
        <div class="mtr-info-item">
          <span class="mtr-label">交易編號</span>
          <span class="mtr-value">{{ tableData.orderNo }}</span>
        </div>
        <div class="mtr-info-item">
          <span class="mtr-label">付費日期</span>
          <span class="mtr-value">{{ formatDateTime(tableData.payedAt) || '---' }}</span>
        </div>
        <div class="mtr-info-item">
          <span class="mtr-label">訂閱學生數目</span>
          <span class="mtr-value">{{ tableData.studentQuantity }}</span>
        </div>
        <div class="mtr-info-item">
          <span class="mtr-label">小計</span>
          <span class="mtr-value">{{ addComma(tableData.totalPrice) }}</span>
        </div>
        <div class="mtr-info-item">
          <span class="mtr-label">折扣</span>
          <span class="mtr-value">{{ addComma(tableData.totalPrice - tableData.payPrice) }}</span>
        </div>
        <div v-if="tableData.promotionCode" class="mtr-info-item mtr-promo">
          <span class="mtr-label">已使用推廣碼</span>
          <span class="mtr-value">{{ tableData.promotionCode }}</span>
        </div>
      </div>

      <!-- MTR风格学生明细 -->
      <div class="mtr-student-list">
        <div class="mtr-list-title">學生訂閱明細</div>
        <div class="mtr-student-item" v-for="(item, i) in tableData.orderItems" :key="i">
          <div class="mtr-col1">{{ item.student }}</div>
          <div class="mtr-col2">{{ item.grade }}</div>
          <div class="mtr-col3">{{ dateFormatter(item) }}</div>
          <div class="mtr-col4">{{ priceFormatter(item) }}</div>
        </div>
      </div>

      <!-- MTR风格底部声明 -->
      <div class="mtr-footer">
        本服務由 MathConcept Online 提供
      </div>
    </div>

    <!-- ========== PC端：原有内容区域 ========== -->
    <div id="pdfDom" class="pc-content showPC" style="padding: 2.25rem 5vw">
      <div style="font-size: 2rem; line-height: 2rem; font-weight: bold; color: #b62d2e">訂閱付費紀錄詳細 <span style="white-space: nowrap">Subscribe Record Details</span></div>
      <div style="display: flex; margin-top: 0.5rem; margin-bottom: 1rem">
        <span style="width: 1rem; height: 1rem; background: #b62d2e; border-radius: 50%; margin-right: 1rem"></span>
        <span style="width: 1rem; height: 1rem; background: #de5934; border-radius: 50%; margin-right: 1rem"></span>
        <span style="width: 1rem; height: 1rem; background: #f1aa55; border-radius: 50%; margin-right: 1rem"></span>
      </div>
      <div>
        <h5 style="margin-right: 20px">交易編號 Transaction number：{{ tableData.orderNo }}</h5>
        <h5 style="margin-right: 5.5rem">付費日期 Payment date：{{ formatDateTime(tableData.payedAt) || "---" }}</h5>
        <h5 style="margin-right: 5.5rem">訂閱學生數目 Subscribed Number：{{ tableData.studentQuantity }}</h5>
        <div class="table-box" ref="print">
          <el-table :data="tableData.orderItems" style="width: 100%">
            <el-table-column prop="student" :label="'學生帳戶\nStudent Account'" width="300"> </el-table-column>
            <el-table-column prop="grade" :label="'年級\nGrade'" width="200">
              <template slot-scope="{ row }">
                {{ row.grade}}
              </template>
            </el-table-column>
            <el-table-column :label="'訂閱時段\nSubscription Period'" width="240" :formatter="dateFormatter"> </el-table-column>
            <el-table-column prop="price" :label="'價格\nPrice'" min-width="260" align="right" :formatter="priceFormatter"> </el-table-column>
          </el-table>
          <div class="price-box">
            <div>小計 Subtotal：</div>
            <div style="width: 10rem">{{ addComma(tableData.totalPrice) }}</div>
          </div>
          <div class="price-box">
            <div>折扣 Discount：</div>
            <div style="width: 10rem">
              {{ addComma(tableData.totalPrice - tableData.payPrice) }}
            </div>
          </div>
          <div v-if="tableData.promotionCode" class="price-box" style="color: #b62d2e; font-weight: bold">
            <div>已使用推廣碼 Used Promotion Code：</div>
            <div style="width: 10rem">{{ tableData.promotionCode }}</div>
          </div>
          <div class="price-box">
            <div>總計 Total：</div>
            <div style="width: 10rem">{{ addComma(tableData.payPrice) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderDetail } from "@/api/order";
import { formatDate, formatDateTime2 } from "@/filters";
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      tableData: {},
      enGradeList: {
        小一: "Primary One",
        小二: "Primary Two",
        小三: "Primary Three",
        小四: "Primary Four",
        小五: "Primary Five",
        小六: "Primary Six",
      },
      htmlTitle: "訂閱付費紀錄詳細 Subscribe Record Details",
    };
  },
  watch: {
    "$store.getters.language": {
      handler() {
        this.$forceUpdate();
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
    this.getOrderDetail(this.id);
  },
  methods: {
    onBack() {
      this.$router.go(-1);
    },
    getOrderDetail(id) {
      getOrderDetail(id).then((v) => {
        this.tableData = v.data;
        this.htmlTitle = this.tableData.orderNo;
      });
    },
    dateFormatter(row) {
      return this.addDate(row.startDate);
    },
    addDate(date) {
      var start = new Date(date);
      var end = new Date(date);
      end.setFullYear(end.getFullYear() + 1);
      end.setDate(end.getDate() - 1);
      return formatDate(start) + " - " + formatDate(end);
    },
    formatDateTime(date) {
      return formatDateTime2(date);
    },
    priceFormatter(row) {
      return this.addComma(row.price);
    },
    addComma(num, i) {
      if (i == 1) return num ? `- HKD $${num.toLocaleString()}` : "HKD $0";
      return num ? `HKD $${num.toLocaleString()}` : "HKD $0";
    }
  },
};
</script>

<style lang="scss" scoped>
// ========== 基础控制 ==========
.showPC { display: block !important; }
.showPhone { display: none !important; }

// ========== PC端原有样式（完全保留） ==========
.pc-header { position: relative; }
.detail-box {
  display: flex;
  margin-top: 2rem;
  flex-wrap: wrap;
}
.table-box {
  padding: 1.25rem 0;
}
.detail-button {
  font-size: 1rem;
  border: 0.0625rem solid #fcc03a;
  font-weight: bold;
  color: #444444;
  border-radius: 1.625rem;
  line-height: 2.5;
  background: none;
  position: absolute;
  margin-top: 6.75rem;
  margin-right: 5vw;
  white-space: nowrap;
}
.price-box {
  display: flex;
  justify-content: flex-end;
  text-align: right;
  margin-top: 1rem;
  margin-right: 8rem;
}

::v-deep {
  .el-table {
    font-size: 1rem;
  }
  .el-table .cell {
    padding: 0;
  }
  .el-table th.el-table__cell > .cell {
    padding: 0;
    white-space: pre-wrap;
  }
  .el-table th {
    background: #fceedd;
    color: #444444;
  }
  .el-table th:first-child {
    padding-left: 6rem;
  }
  .el-table td:first-child {
    padding-left: 6rem;
  }
  .el-table th:nth-child(4) {
    padding-right: 8rem;
  }
  .el-table td:last-child {
    padding-right: 8rem;
  }
}

// ========== 手机端：MTR支付凭证样式（带返回按钮） ==========
@media (max-width: 768px) {
  .showPC { display: none !important; }
  .showPhone { display: block !important; }

  .mtr-wrapper {
    max-width: 480px;
    margin: 0 auto;
    background: #fff;
    min-height: 100vh;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    padding-bottom: 60px;
  }

  // MTR顶部（带返回按钮）
  .mtr-header {
    position: relative;
    text-align: center;
    padding: 30px 20px 20px;
    border-bottom: 1px solid #eee;
    .mtr-back-btn {
      position: absolute;
      left: 20px;
      top: 30px;
      font-size: 20px;
      color: #333;
      cursor: pointer;
      z-index: 10;
    }
    .mtr-title {
      font-size: 18px;
      color: #333;
      margin-bottom: 15px;
      font-weight: 500;
    }
    .mtr-amount {
      font-size: 32px;
      font-weight: 500;
      color: #b62d2e;
    }
  }

  // MTR信息列表
  .mtr-info-list {
    padding: 15px 20px;
    .mtr-info-item {
      display: flex;
      justify-content: space-between;
      padding: 12px 0;
      border-bottom: 1px solid #f5f5f5;
      &:last-child { border-bottom: none; }

      .mtr-label {
        font-size: 15px;
        color: #666;
      }
      .mtr-value {
        font-size: 15px;
        color: #333;
        text-align: right;
        max-width: 60%;
        word-break: break-all;
      }
    }
    .mtr-promo .mtr-value {
      color: #b62d2e;
      font-weight: bold;
    }
  }

  // MTR学生明细
  .mtr-student-list {
    padding: 15px 20px;
    border-top: 8px solid #f5f5f5;
    .mtr-list-title {
      font-size: 16px;
      font-weight: 500;
      color: #333;
      margin-bottom: 10px;
    }
    .mtr-student-item {
      display: flex;
      padding: 10px 0;
      border-bottom: 1px solid #f5f5f5;
      &:last-child { border-bottom: none; }

      .mtr-col1 {
        font-size: 14px;
        color: #333;
        flex: 1;
      }
      .mtr-col2 {
        font-size: 14px;
        color: #666;
        width: 60px;
        text-align: center;
      }
      .mtr-col3 {
        font-size: 12px;
        color: #999;
        width: 100px;
        text-align: center;
      }
      .mtr-col4 {
        font-size: 14px;
        color: #333;
        width: 80px;
        text-align: right;
      }
    }
  }

  // MTR底部声明
  .mtr-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    max-width: 480px;
    margin: 0 auto;
    padding: 15px 20px;
    background: #f5f5f5;
    text-align: center;
    font-size: 12px;
    color: #999;
  }
}

// 原有媒体查询兼容
@media (min-width: $minWidth) and (max-width: $maxWidth) {}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .contain { height: 100%; }
  .detail-button { margin-top: 9.75rem; }
}
</style>